import { ColumnDef } from "@tanstack/react-table";

import { TIMEZONES } from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";
import { VisitType, visitTypeLabels } from "~/services";
import { ProviderAppointment } from "~/services/admin-providers";
import { dateToUsFormat } from "~/shared/utils";
import { CompactTable } from "~/ui/table/CompactTable";

const columns: ColumnDef<ProviderAppointment>[] = [
  {
    header: "Date/Time",
    accessorKey: "startAt",
    cell: ({ row }) => dateToUsFormat(row.original.startAt, TIMEZONES.ET.code),
  },

  {
    header: "Visit Type",
    accessorKey: "appointmentType",
    cell: ({ row }) =>
      visitTypeLabels[row.original.appointmentType as VisitType] ?? "—",
  },
  {
    header: "Patient ID",
    accessorKey: "patientId",
    cell: ({ row }) => row.original.patientId ?? "-",
  },
];

export const BookingConflictsTable = ({
  data,
}: {
  data: ProviderAppointment[];
}) => {
  return (
    <CompactTable
      data={data}
      columns={columns}
      emptyState="No booking conflicts found."
      maxHeightClassName="max-h-44"
      tdClassName="pb-2"
    />
  );
};
